import classNames from 'classnames';
import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';

import s from './AgeConfirmationModal.sss';

interface Props {
  className?: string,
  isOpen: boolean,
  onConfirm: () => void,
  onCancel: () => void,
}

export const AgeConfirmationModal: React.FC<Props> = ({
  className,
  isOpen,
  onConfirm,
  onCancel,
}) => (
  <Modal
    className={classNames(s.modal, className)}
    overlayClassName={s.overlay}
    isOpen={isOpen}
    animate={false}
  >
    <Title
      className={s.title}
      type="h3"
      bold={false}
    >
      {t`Підтвердіть свій вік`}
    </Title>
    <p className={s.description}>
      {t`Вам вже виповнилося 18 років?`}
    </p>

    <div className={s.buttons}>
      <Button
        className={s.button}
        theme="secondary"
        onClick={onCancel}
      >
        {t`Ні, не виповнилося`}
      </Button>
      <Button
        className={s.button}
        onClick={onConfirm}
      >
        {t`Так, виповнилося`}
      </Button>
    </div>
  </Modal>
);
